/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-continue */
/* eslint-disable object-curly-newline */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable no-lone-blocks */
/* eslint-disable no-console */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable max-len */
/* eslint-disable no-plusplus */
import React, { useState } from "react";

import Carousel from "react-material-ui-carousel";

import useMediaQuery from "@mui/material/useMediaQuery";
import Grid from "@mui/material/Grid";

import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

import { useScreenSize } from "../../../../component/Theme";

export interface SompoCarouselProps {
    careers: any[];
}

const { mobile } = useScreenSize();

// React-MUI-Carousel用の設定(モバイル専用)
const defaultCarouselSetting = {
    autoPlay: false,
    navButtonsAlwaysInvisible: true,
    cycleNavigation: false,
};

const getReactCarouselColumns = (): number => {
    const matches2: boolean = useMediaQuery(() => "@media (max-width: 523px)");
    const matches3: boolean = useMediaQuery(() => "@media (min-width: 524px) and (max-width: 700px)");
    const matches4: boolean = useMediaQuery(() => "@media (min-width: 701px) and (max-width: 1000px)");
    const matches4Mobile: boolean = !matches4 && mobile;

    if (matches2) {
        // window.alert("matches: 2");
        return 2;
    }

    if (matches3) {
        // window.alert("matches: 3");
        return 3;
    }
    if (matches4) {
        // window.alert("matches: 4");
        return 4;
    }
    if (matches4Mobile) {
        // window.alert("matches: 4_Mobile");
        return 4;
    }
    // window.alert("matches: 5");
    return 5;
};

// モバイルカルーセル用の分割配列作成メソッド
const toFormatterdCareers = (career: Array<any>, cardsPerSlide: number) => {
    const length = Math.ceil(career.length / cardsPerSlide);
    return new Array(length).fill(career).map((_, i) => career.slice(i * cardsPerSlide, (i + 1) * cardsPerSlide));
};
// カルーセルに表示する講座カードの行数
export const ROWS = 2;

const SompoHistoryCarousel = (props: SompoCarouselProps) => {
    // 分割数を画面サイズとデバイスから決定する
    const columns = getReactCarouselColumns();
    const cardsPerSlide = columns * ROWS;

    const { careers } = props;

    const [slide, setSlide] = useState<number>(0);

    // ボタンやフィルタが押された際に常に１枚目のスライドを表示するために使用
    React.useEffect(() => {
        setSlide(0);
    }, [props.careers, window.screen.orientation.angle]);

    const next = () => {
        const nextSlide = Math.min(slide + 1, (careers || []).length - 1);
        setSlide(nextSlide);
    };

    const prev = () => {
        const prevSlide = Math.max(slide - 1, 0);
        setSlide(prevSlide);
    };

    const formatterdCareers = toFormatterdCareers(careers, cardsPerSlide);
    // window.alert(`innerRow: ${formatterdCareers[0].length} `);

    // ドットを押下した場合、飛んだページNoが保持されるようにする必要があるため利用する
    const handleOnchange = (current: number | undefined) => {
        setSlide(current || 0);
    };

    // 講座カードの配列から該当する講座カードを入れ、スライドを作成
    const carouselSlides = () => {
        const carouselSlide = [];
        for (let slideNum: number = 0; slideNum <= formatterdCareers.length - 1; slideNum++) {
            carouselSlide.push(
                <Grid
                    id={`${slideNum}`}
                    item
                    sx={{
                        height: "660px",
                        display: "grid",
                        gridTemplateRows: `repeat(${ROWS}, 1fr)`,
                        gridTemplateColumns: `repeat(${columns}, 1fr)`,
                        gridAutoFlow: "column",
                    }}
                >
                    {formatterdCareers[slideNum]}
                </Grid>
            );
        }
        return carouselSlide;
    };

    return (
        <Carousel
            animation={"slide"}
            indicatorIconButtonProps={{
                style: {
                    width: "30px",
                    height: "20px",
                },
            }}
            activeIndicatorIconButtonProps={{
                style: {
                    color: "cc0022",
                },
            }}
            IndicatorIcon={<FiberManualRecordIcon fontSize="small" />}
            {...defaultCarouselSetting}
            sx={{ textAlign: "center", gridAutoFlow: "column" }}
            index={slide}
            next={next}
            prev={prev}
            onChange={handleOnchange}
        >
            {carouselSlides()}
        </Carousel>
    );
};

export default SompoHistoryCarousel;
